<template>
    <div class="polyline-switch">
        <div :class="isPolyline ? 'active' : ''" class="item first" @click="switchPolylineMode(true)">
            <div class="dot polyline">
                直 线
            </div>
        </div>
        <div :class="isPolyline ? '' : 'active'" class="item last" @click="switchPolylineMode(false)">
            <div class="dot route">路 径</div>
        </div>
    </div>
</template>

<script>
import { MapController } from '../adjust/map/mapController';

export default {
    name: 'polyline-switch',
    data() {
        return {
            isPolyline: true
        };
    },
    props: {
        mapController: MapController
    },
    methods: {
        switchPolylineMode(isPolyline) {
            if (isPolyline !== this.isPolyline) {
                this.isPolyline = isPolyline;
                this.mapController.switchPolylineMode(isPolyline);
            }
        }
    }
};
</script>

<style lang="less" scoped>
.polyline-switch {
    background-color: white;
    border-radius: 4px;
    display: flex;
    position: absolute;
    left: 14px;
    top: 10px;
    z-index: 100;

    .item {
        width: 40px;
        text-align: center;
        padding: 6px 10px;
        border-left: 1px solid #00bcbe;
        cursor: pointer;
        font-size: 12px;
        color: #2c2931;

        &.active {
            color: white;
            background-color: #00bcbe;
        }
    }

    .first {
        border-left: 0;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    .last {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
    }
}
</style>
